/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.4"
        height="95.95"
        viewBox="0 0 95.4 95.95"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M43.34 20.42a1.49 1.49 0 0 1 2-.05l.11.1L63.98 40a1.5 1.5 0 0 1-2.06 2.18l-.13-.18-18.5-19.5a1.5 1.5 0 0 1 .05-2.08ZM56.42 63.58a1.5 1.5 0 0 1 1 2.81h-.14l-22 7a1.5 1.5 0 0 1-1-2.81h.13Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M9.73 61.24a18.45 18.45 0 1 0 25 7.57 18.46 18.46 0 0 0-25-7.57Zm22.32 9a15.45 15.45 0 1 1-20.91-6.37 15.46 15.46 0 0 1 20.9 6.32Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M74.86 36.5a20.5 20.5 0 1 0 18.12 10.84A20.51 20.51 0 0 0 74.86 36.5m0 3a17.51 17.51 0 1 1-8.23 2.07 17.52 17.52 0 0 1 8.23-2.07"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M30.89 1.53a12.91 12.91 0 1 0 17.48 5.3 12.91 12.91 0 0 0-17.48-5.3Zm14.83 6.71a10 10 0 1 1-.14-.24Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ThreeConnectedNodesIcon';

export default Icon;
